









































import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix = 'sw-dropdown-unit';

export default Vue.extend({
  functional: true,
  props: {
    disabled: { type: Boolean, default: false },
    highlight: { type: Boolean, default: false },
    clickable: { type: Boolean, default: true },
    selected: { type: Boolean, default: false },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    const data = utilService.extractFunctionalCompRootNodeData(context.data);

    return (
      <div
        class={[
          `${cssPrefix}`,
          'sw-flexbox',
          'sw-flexbox--center-items',
          {
            [`${cssPrefix}--disabled`]: context.props.disabled,
            [`${cssPrefix}--highlight`]: context.props.highlight,
            [`${cssPrefix}--not-clickable`]: !context.props.clickable,
            [`${cssPrefix}--selected`]: context.props.selected,
          },
        ]}
        { ...data }
      >
      { utilService.getVueScopedSlot(context.scopedSlots) }
      </div>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
